import { defineComponent as _defineComponent } from 'vue'
import { watch, ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { config } from '@/store';
import chapterApi from '@/api/chapter';
import { ElMessageBox } from 'element-plus';
import i18n from '@/i18n';
import { add_collect, is_collect, remove_collect } from '@/api/collect';


export default /*#__PURE__*/_defineComponent({
  __name: 'right-sidebar',
  props: ['info', 'menuPoster'],
  emits: ['reload'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const { t } = i18n.global;

const route = useRoute();

const drawer = ref(false);
const isCollect = ref(false);

const props = __props;
const emit = __emit;

const chapterName = computed(() => {
	return props.info.chapterName;
});

const chapterId = computed(() => {
	return props.info.chapterId;
});

const blob = computed(() => {
	return props.menuPoster;
});

watch(
	() => config.rightSidebar,
	(val) => {
		drawer.value = val;
	}
);

watch(
	() => props.info.chapterId,
	async (val) => {
		const res = await is_collect('chapter', val);
		isCollect.value = res.data.request;
	}
);

function close_sidebar() {
	config.rightSidebar = false;
}

async function update_collect_state() {
	const res = await is_collect('chapter', chapterId.value);
	isCollect.value = res.data.request;
}

async function menu_select(key: string) {
	const chapterInfo = props.info;

	switch (key) {
		case 'remove':
			ElMessageBox.confirm(t('chapterManage.confirm.text1'), {
				type: 'warning',
			}).then(async () => {
				await chapterApi.delete_chapter(chapterId.value);
				emit('reload');
			});

			break;
		case 'delete':
			ElMessageBox.confirm(t('chapterManage.confirm.text2'), {
				type: 'warning',
			}).then(async () => {
				await chapterApi.delete_chapter(chapterId.value, true);
				emit('reload');
			});
			break;
		case 'collect':
			if (isCollect.value) {
				await remove_collect('chapter', chapterId.value);
			} else {
				await add_collect(
					Object.assign(chapterInfo, {
						collectType: 'chapter',
					})
				);
			}

			update_collect_state();
			break;
	}
	close_sidebar();
}

const __returned__ = { t, route, drawer, isCollect, props, emit, chapterName, chapterId, blob, close_sidebar, update_collect_state, menu_select, get config() { return config } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})